import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useI18n } from 'builder/hooks/useI18n'

import { actions as jobSearchActions } from 'builder/modules/jobSearch'
import Button, { ButtonSize, ButtonTheme } from 'builder/components/Button'
import { AlertTypes, FrequencyType } from 'builder/modules/jobSearch/types'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { DialogModalV2 } from 'builder/components/DialogModal/DialogModalV2/DialogModalV2'
import Select from 'builder/components/Select'

import { useTranslatedFrequenciesString } from '../hooks/useTranslatedFrequenciesString'
import { useMutationRecommendationAlert } from '../hooks/useMutationRecommendationAlert'
import { useGetRecommendationAlert } from '../hooks/useGetRecommendationAlert'
import { WrapperButtons, WrapperSelect } from './styles'

const TRANSLATION = 'builder.job_search.alert_modal.edit_recommend_alert'

export const EditRecommendAlert = () => {
  const { i18n } = useI18n()
  const { frequencies } = useTranslatedFrequenciesString()
  const mutationRecommendationAlert = useMutationRecommendationAlert()
  const recommendationAlert = useGetRecommendationAlert()
  const dispatch = useDispatch()
  const { isPhone } = useMediaQueries()
  const [frequency, setFrequency] = useState<FrequencyType>(
    recommendationAlert.data?.frequency || FrequencyType.daily,
  )

  const handleEditRecommendAlert = async () => {
    await mutationRecommendationAlert.mutateAsync({ data: { frequency }, shouldUpdateCache: true })
    dispatch(jobSearchActions.setAlertType({ type: AlertTypes.manage }))
  }

  return (
    <DialogModalV2
      onClose={() => dispatch(jobSearchActions.setAlertType({ type: undefined }))}
      title={i18n.t(`${TRANSLATION}.title`)}
      subtitle={i18n.t(`${TRANSLATION}.subtitle`)}
    >
      <WrapperSelect>
        <Select<FrequencyType>
          label={i18n.t(`${TRANSLATION}.frequency`)}
          selected={frequency}
          onSelect={setFrequency}
          disabled={frequencies.length === 1}
          options={frequencies}
        />
      </WrapperSelect>
      <WrapperButtons>
        <Button
          size={isPhone ? ButtonSize.small : ButtonSize.default}
          theme={ButtonTheme.ghost}
          onClick={() => dispatch(jobSearchActions.setAlertType({ type: AlertTypes.manage }))}
        >
          {i18n.t(`${TRANSLATION}.back`)}
        </Button>
        <Button
          size={isPhone ? ButtonSize.small : ButtonSize.default}
          isLoading={mutationRecommendationAlert.isLoading}
          onClick={handleEditRecommendAlert}
        >
          {i18n.t(`${TRANSLATION}.save`)}
        </Button>
      </WrapperButtons>
    </DialogModalV2>
  )
}
